<template>
   <div class="template-wrapper">
          <img class="inventory-image" :src="message.AttachmentFile.Payload.VehicleImage">
          <!-- , click: function(){ $parent.showImagePreview(message.AttachmentFile.Payload.VehicleImage); }" -->
          <table class="inventory-info-table">
            <tbody>
              <tr>
                <td class="inventory-title" colspan="2">
                  <a v-html="message.AttachmentFile.Payload.Title" :href="message.AttachmentFile.Payload.Url" target="_blank"></a>
                </td>
              </tr>
              <tr>
                <td>Stock #</td>
                <td v-html="message.AttachmentFile.Payload.StockNo"></td>
              </tr>
              <tr>
                <td>Color</td>
                <td v-html="message.AttachmentFile.Payload.ColorExt"></td>
              </tr>
              <tr>
                <td>Mileage</td>
                <td v-html="message.AttachmentFile.Payload.Mileage"></td>
              </tr>
              <tr>
                <td>Engine</td>
                <td v-html="message.AttachmentFile.Payload.Engine"></td>
              </tr>
              <tr>
                <td>Transmission</td>
                <td v-html="message.AttachmentFile.Payload.Transmission"></td>
              </tr>
              <tr>
                <td class="mileage-info">
                  <img src="static/assets/img/gasoline_icon.svg" class="mileage-icon" />
                  <div class="mileage-detail">
                    CITY
                    <span v-html="message.AttachmentFile.Payload.MpgCity"></span>
                    <br> HWY
                    <span v-html="message.AttachmentFile.Payload.MpgHighway"></span>
                  </div>
                </td>
                <td style="color: #8d8d8d; padding-top: 5px;">
                  EPA estimated ratings
                  <br>Actual mileage will wary
                </td>
              </tr>
              <tr>
                <td colspan="2" align="right" style="padding-top: 5px;">
                  PRICE:
                  <b v-html="'$'+message.AttachmentFile.Payload.Price"></b>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
</template>

<script>
export default {
    name: 'inventoryPayload',
    data(){
        return {
            message: {}
        }
    },
    created (){
        this.message = this.$parent._props.message
    }
}
</script>

<style lang="scss" scoped>


  .template-wrapper {
    width: 100%;
    padding: 10px;
    border-radius: 5px;
    overflow: hidden;
    background: #f5f5f5;
    color: #808080;
    width: 300px;

    .inventory-image {
      width: 100%;
      height: auto;
      display: block;
      cursor: pointer;
      padding: 5px 0px;
    }

    .inventory-info-table {
      width: 100%;

      td {
        vertical-align: top;
        padding-right: 10px;

        &.mileage-info {
          padding-top: 5px;

          .mileage-icon {
            width: 25px;
            height: 30px;
            float: left;
            margin: 5px 4px 0px 0px;
            vertical-align: super;
          }

          .mileage-detail {
            display: inline-block;
            font-weight: 500;
            margin-left: 5px;
          }
        }
      }

      .inventory-title {
        padding: 5px 0px;
        font-weight: 500;

        a {
          color: $blue-lt;
        }
      }
    }
  }


</style>




// WEBPACK FOOTER //
// src/components/Messenger/MessageList/Message/MessageAttachment/InventoryPayload.vue